import React from 'react'


import Tabs from './Components/Tabs'
import Search from './Search'
import Header from './Components/Header'
import Record from './Record'
import { QuestionTop, QuestionBottom } from './Question'
import Feedback from './Feedback'
import QuestionDetail from './QuestionDetail'
import LiveChat from './Components/LiveChat'
import Tag from './Components/Tag'


import Components from './../Components'

import Config from '../Config'
const { SpinLoading, platform } = Config()


export default class CustomerService extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            token: '',
            isLogin: false
        }
    }

    componentDidMount() {
        platform == 'Mobile' && window.addEventListener('message', this.handleMessage);
    }

    handleMessage = (event) => {
        const json = event?.data;
        try {
            let message = JSON.parse(json) || {}
            let { isFrom = '', token = '' } = message
            localStorage.setItem("fromApp", "1");
            if (token) {
                localStorage.setItem('memberToken', JSON.stringify('Bearer ' + token));
                localStorage.setItem("loginStatus", "1");
                this.setState({
                    token: JSON.parse(localStorage.getItem('memberToken')),
                    isLogin: localStorage.getItem("loginStatus") == 1
                })
            }

        } catch (e) {
        }
    };

    render() {
        return <div id='CustomerService' className={platform}>
            <SpinLoading></SpinLoading>
            <Components
                Header={Header}
                Tabs={Tabs}

                Record={Record}
                QuestionTop={QuestionTop}
                QuestionBottom={QuestionBottom}

                Feedback={Feedback}
                QuestionDetail={QuestionDetail}

                Search={Search}
                LiveChat={LiveChat}

                Tag={Tag}
            >
            </Components>
        </div>
    }
}